import { useEffect, useState } from "react";
import { Globe, Monitor, Settings, HelpCircle, UserPlus, Sparkles, Send } from "lucide-react";
import { FlowerLogo } from "../FlowerLogo";
import { useI18n } from "../../lib/i18n";

const useClock = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 15000); return () => clearInterval(id); }, []);
  return now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export const MENU = [
  ["register", "navRegister", "#register", UserPlus],
  ["status", "navStatus", "#status", Monitor],
  ["clients", "navClients", "#clients", Settings],
  ["faq", "navFaq", "#faq", HelpCircle],
  ["webclient", "rtWebT", "https://kicq.su", Globe],
  ["telegram", "telegram", "https://t.me/kicq_official", Send],
];

const StartMenu = ({ onClose, setTheme }) => {
  const { t } = useI18n();
  return (
    <div data-testid="start-menu" className="w98-window absolute bottom-[42px] left-1 flex min-w-[230px] !p-[3px]">
      <div className="w98-menu-side">KICQ 2000</div>
      <div className="flex-1 py-1">
        {MENU.map(([id, key, href, Icon]) => (
          <a key={id} href={href} onClick={onClose} data-testid={`start-menu-${id}`} className="w98-menu-item"
            {...(href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
            <Icon className="h-5 w-5" />{t(key)}
          </a>
        ))}
        <div className="my-1 mx-1 border-t border-[#808080] border-b border-b-white" />
        <button type="button" onClick={() => setTheme("modern")} data-testid="start-menu-modern" className="w98-menu-item">
          <Sparkles className="h-5 w-5" />{t("rtMenuSwitch")}
        </button>
      </div>
    </div>
  );
};

export const RetroTaskbar = ({ status, setTheme }) => {
  const { t, lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const time = useClock();
  const online = status?.online;
  return (
    <footer className="w98-taskbar" data-testid="retro-taskbar">
      {open && <StartMenu onClose={() => setOpen(false)} setTheme={setTheme} />}
      <button type="button" onClick={() => setOpen(!open)} data-testid="start-btn"
        className={`w98-btn !min-w-0 !px-2 font-bold ${open ? "pressed" : ""}`}>
        <FlowerLogo size={18} online={online !== false} />{t("rtStart")}
      </button>
      <div className="hidden md:flex gap-1 flex-1 min-w-0 ml-1">
        {MENU.slice(0, 4).map(([id, key, href]) => (
          <a key={id} href={href} data-testid={`task-btn-${id}`} className="w98-btn !justify-start truncate max-w-[150px]">{t(key)}</a>
        ))}
      </div>
      <div className="flex-1 md:hidden" />
      <a href="https://t.me/kicq_official" target="_blank" rel="noopener noreferrer" data-testid="footer-telegram-btn"
        className="w98-btn !min-w-0 !px-2 text-sm" title="Telegram"><Send className="h-4 w-4 text-[#229ED9]" /><span className="hidden sm:inline">Telegram</span></a>
      <button type="button" onClick={() => setTheme("modern")} data-testid="theme-toggle-btn" className="w98-btn !min-w-0 !px-2 text-sm">
        {t("themeModern")}
      </button>
      <div className="w98-soft flex items-center gap-2 px-2 h-full text-sm">
        <span data-testid="nav-server-badge" className="flex items-center gap-1" title={t(online ? "ONLINE" : "OFFLINE")}>
          <FlowerLogo size={14} online={online !== false} />
          <span className="hidden sm:inline">{online ? `${status.latency_ms}${t("ms")}` : online === false ? t("offline") : "…"}</span>
        </span>
        <span data-testid="lang-switcher" className="flex">
          {["ru", "en"].map((l) => (
            <button key={l} type="button" onClick={() => setLang(l)} data-testid={`lang-${l}-btn`}
              className={`px-1 uppercase ${lang === l ? "bg-[#000080] text-white" : ""}`}>{l}</button>
          ))}
        </span>
        <span data-testid="taskbar-clock" className="hidden sm:inline">{time}</span>
      </div>
    </footer>
  );
};
